import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './auth.service';
import { LoginManagerService } from './login-manager.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityLayerService {

  // used due to Guard being separated as Login Manager
  private loginObj;

  constructor(private loginManager: LoginManagerService,private _snackBar: MatSnackBar, private authService: AuthService) { }
  
  tryLogin(loginObj){
    this.loginObj = loginObj;
    this.authService.tryLogin(loginObj);
  }

  isLoginManagerLoading(){
    return this.loginManager.getLoading();
  }

  getCookie(cookie){
    return this.loginManager.getCookie(cookie);
  }

  registerCloseSession(){
    this.authService.closeSession();
  }

  delete_cookie(name) {
    this.loginManager.delete_cookie(name);
  }

  isUserLoggedIn(){
    if(this.loginManager.getSessionData()){
      return this.loginManager.getSessionData().logged;
    }else{
      return false;
    }
  }

  getSecurityLayerObj(){
    return this.loginObj;
  }

  saveLoginObj(obj){
    this.loginObj = obj;
  }

  getSessionData(){
    return this.loginManager.getSessionData();
  }

  openSimpleSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  checkForCookies(path){
    return this.loginManager.checkForCookies(path)
  }

  isLoading(){
    return this.loginManager.isLoading();
  }
}
